/* screens/support/PublicSupport.jsx — ПУБЛИЧНАЯ страница поддержки /help.
   Доступна БЕЗ регистрации/авторизации (вне AppShell и гардов). Гость опознаётся
   по X-Support-Token (см. lib/api/support.js). Логика — общий SupportTicketsPanel
   с проп guest (поля имени/почты в новой заявке). */
import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { RR } from '../../lib/router.jsx';
import { SupportTicketsPanel } from './SupportTicketsPanel.jsx';

const { useSearchParams, useNavigate } = RR;

function PublicSupport() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ticket = params.get('ticket');

  // «Назад» — вернуться откуда пришли (обычно экран входа). Если истории нет
  // (открыли /help прямой ссылкой) — ведём на вход, чтобы из окна был выход.
  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) navigate(-1);
    else navigate('/signin');
  };

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column',
                  background: 'var(--surface-1, #f7f8fa)' }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px',
                       borderBottom: '1px solid var(--border, #e5e7eb)', background: '#fff' }}>
        <Button variant="ghost" size="sm" iconLeft="arrow-left" onClick={goBack}>Назад</Button>
        <span style={{ flex: 1 }} />
        <img src="/logo-mark.svg" alt="" width={24} height={24} />
        <span style={{ fontWeight: 700, fontSize: 15 }}>Ресториум</span>
        <span style={{ flex: 1 }} />
        <Button variant="ghost" size="sm" onClick={() => navigate('/signin')}>Войти</Button>
      </header>

      <main style={{ flex: 1, width: '100%', maxWidth: 760, margin: '0 auto',
                     padding: '24px 16px 40px', boxSizing: 'border-box' }}>
        <h1 className="t-h2" style={{ marginBottom: 4 }}>Чем помочь?</h1>
        <p className="text-dim" style={{ marginBottom: 20 }}>
          Опишите вопрос — команда поддержки ответит прямо здесь. Регистрация не нужна;
          ваши обращения сохраняются в этом браузере.
        </p>
        {/* Согласие на обработку ПД живёт ВНУТРИ формы обращения (дровер), а не
            здесь: дровер перекрывает страницу целиком (на ≤720px — во всю
            ширину), и текст под ним человек в момент ввода телефона не видит. */}
        <SupportTicketsPanel guest autoOpenId={ticket} />
      </main>
    </div>
  );
}

export { PublicSupport };
